// import { AppConfig } from 'config/app';
// import TextyAnim from 'rc-texty';
import React from "react";
import { Col, Row } from 'reactstrap';

import TextLoop from "react-text-loop";
// import ScrollAnimation from 'react-animate-on-scroll';
// import Card from 'reactstrap/lib/Card';

// import Error from 'components/alerts/Error';
// import RequestAccess from 'components/common/controls/navbar/RequestAccess';
// import { openModal } from 'components/modal/modules/dispatcher/methods';
// import coin from './SVG/coin.svg'
import ear from './SVG/ear.svg'
import law from './SVG/law.svg'
// import search from './SVG/search.svg'
// import shield from './SVG/shield-check.svg'
import tool from './SVG/tool.svg'
// import user from './SVG/user-plus.svg'

export default class LandingPage extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

  public myRef1: any;
  public myRef2: any;

  constructor(props) {
    super(props);
    this.myRef1 = React.createRef()
    this.myRef2 = React.createRef()
    this.scroll1 = this.scroll1.bind(this)
    this.scroll2 = this.scroll2.bind(this)
  }

  public scroll1() {
    window.scrollTo(0, this.myRef1.current.offsetTop - 225)
  }

  public scroll2() {
    window.scrollTo(0, this.myRef2.current.offsetTop - 165)
  }

  public render() {

    // const gradient1 = require('./gradient1.png')
    const mobileDashboard = require('./isotope-images/top-right.png')
    const center = require('./isotope-images/center-image.png')
    const illustration = require('./isotope-images/illustration.png')
    const events = require('./isotope-images/center-right.png')
    const anim1 = require('./anim1.mp4')
    const anim2 = require('./anim2.mp4')

    return <div style={{ marginTop: '-80px', maxWidth: '100%', overflowX: 'hidden' }}>
      {/* THE FOLLOWING IS CODE FOR THE LANDING PAGE FOR DEVICES WITH SCREEN WIDTHS OVER 768 */}
      <div className='big-split-768'>
        {/* BLOCK 1 */}
        <div>
          <div className="con" style={{ width: '40%', float: 'right' }}>
            <div className="layer1">
              <video style={{
                width: '200%',
                textAlign: 'center',
                borderBottomLeftRadius: '35px',
                backdropFilter: 'blur(5px)',
              }} autoPlay={true} loop={true}>
                <source src={anim2} type="video/mp4" />
              </video>
            </div>
            <div className="layer2" style={{ width: '100%', textAlign: 'center' }}>
              <img src={mobileDashboard} style={{ width: screen.width > 1000 ? '65%' : '90%', paddingTop: '175px' }} />
            </div>
          </div>
        </div>
        <div style={{ width: '70%', paddingLeft: '50px' }}>
          <div className='container' style={{ flexDirection: 'column', display: 'flex' }}>
            <p style={{ paddingTop: '160px', fontSize: screen.width > 768 && screen.width < 1000 ? '60px' : '74px', fontFamily: 'Inter', color: '#242d51', width: '100%' }}>
              Promote<br />Your Events<br />
            </p>
            <div style={{ width: '100%', fontSize: screen.width > 768 && screen.width < 1000 ? '60px' : '74px', fontFamily: 'Inter', color: '#242d51' }}>
              <span className='cut-text' style={{ color: '#fff', borderRadius: '15px', backgroundColor: '#242d51', width: 'auto', float: 'left' }}>
                &nbsp;Successfully.&nbsp;
              </span>
            </div>
            <div style={{ width: '100%', paddingTop: '15px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ width: '100%' }}>
                <p style={{ width: '80%', float: 'left', fontSize: '26px', paddingTop: '10px', paddingBottom: '10px' }}>
                  Empower your team to maximise outreach and increase word-of-mouth for a memorable event.
                </p>
              </div>
              <div style={{ flexDirection: 'row', textAlign: 'left', width: '100%' }}>
                <span>
                  <a href='https://app.isotopeticketing.com/'>
                    <button className='new-button-blue-gradient'>
                      START NOW
              </button>
                  </a>
                </span>
                <span style={{ paddingLeft: '25px' }}>
                  <a href='mailto:info@isotopeticketing.com'>
                    <button className='new-button-blue-outline'>
                      CONTACT SALES
              </button>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 2 */}
        {/* BLOCK 3 */}
        <div style={{ width: '100%', textAlign: 'center', marginTop: '125px' }}>
          <img src={center} style={{ width: '90%' }} />
          <div ref={this.myRef1}
            style={{ marginTop: screen.width > 1000 ? '-225px' : '-150px', paddingLeft: screen.width > 1000 ? '0px' : '95px', display: 'flex', justifyContent: 'center' }}>
            {/* <div style={{ textAlign: 'left' }}>
              <p>
                DESIGNED FOR
              </p>
              <p style={{ fontSize: '55px', fontFamily: 'Inter', color: '#242d51' }}>
                PROMOTERS
              </p>
            </div> */}
          </div>
        </div>
        {/* OLD BLOCK 2 */}
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '300px' }}>
          <p style={{ fontSize: '55px', fontFamily: 'Inter', color: '#242d51' }}>
            Harness the power of affiliate marketing.
          </p>
          <p style={{ fontSize: '26px', paddingLeft: '10%', paddingRight: '10%', }}>
            Turn your promoters and their sub-promoters into more points-of-sale.
            Isotope ensures that each affiliate receives a fair share of commission.
          </p>
          {/* <button className='new-button-blue-outline' onClick={() => this.scroll1()}>
            LEARN MORE
        </button> */}
        </div>
        <div style={{ textAlign: 'center', width: '100%' }}>
          <img src={illustration} style={{ width: '65%', textAlign: 'center', marginTop: '125px', marginBottom: '100px' }} />
        </div>
        {/* BLOCK 4 */}
        <div style={{ width: '100%', textAlign: 'center', paddingLeft: '15px', paddingRight: '50px', paddingTop: '50px' }}>
          <div className='container'>
            {/* <p style={{ fontSize: '24px', textAlign: 'left', marginBottom: '50px', paddingTop: '40px' }}>
              Whether it be event tickets or table deposits. Isotope is the operating backbone for your campaign affiliates.
        </p> */}
            <div style={{ width: '100%', textAlign: 'left', marginTop: '50px', marginBottom: '75px' }}>
              <div style={{ width: '50%', float: 'left' }}>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ width: '100%' }}>
                    <p style={{ fontSize: '26px' }}>
                      DESIGNED FOR<br /><br />
                      <div style={{ width: '100%' }}>
                        <div className='cut-text' style={{ color: '#fff', borderRadius: '15px', backgroundColor: '#242d51', width: 'auto', float: 'left', fontSize: '55px', fontFamily: 'Inter' }}>
                          <TextLoop interval={1500}>
                            <span>
                              &nbsp;AFFILIATES&nbsp;
                      </span>
                            <span>
                              &nbsp;AMBASSADORS&nbsp;
                      </span>
                            <span>
                              &nbsp;PROMOTERS&nbsp;
                      </span>
                          </TextLoop>
                        </div>
                      </div><br /><br /><br /><br />
                       Promoters can share unique links to capture a wide variety of audiences. Event-goers can directly purchase inventory from these links, whether it be tickets or tables.
                      </p>
                  </div>
                </div>
              </div>
              <div style={{ width: '50%', float: 'right', paddingLeft: '25px' }}>
                <img src={events} style={{ width: '100%', float: 'right' }} />
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 5 */}
        <div style={{ width: '100%', textAlign: 'center', marginTop: '700px', paddingLeft: '15px', paddingRight: '50px', backgroundColor: '#fff' }}>
          <div className='container'>
            <p style={{ fontSize: '55px', textAlign: 'left', marginBottom: '50px', color: '#242d51', fontFamily: 'Inter', paddingTop: '50px', paddingBottom: '50px' }}>
              WHY ISOTOPE
          </p>
            <div style={{ width: '100%', display: 'flex', height: '425px', paddingBottom: '100px' }}>
              <div style={{ width: '33%', float: 'left', borderLeft: '1px solid #e4e9f2' }}>
                <div style={{ marginBottom: '45px', flexDirection: 'row', display: 'flex' }}>
                  <div className='icon-background' style={{ marginLeft: '20px' }}>
                    <img src={tool} style={{ width: '25px' }} />
                  </div>
                  <div style={{ paddingLeft: '20px', textAlign: 'left' }}>
                    <p style={{ fontSize: '24px', color: '#242d51', fontFamily: 'Inter' }}>
                      All-In-One
                  </p>
                    <p style={{ fontSize: '20px' }}>
                      Manage inventory & affiliate commissions, send email-blasts to customers, check-in tickets, etc.
                    </p>
                  </div>
                </div>
              </div>
              <div style={{ width: '33%', float: 'left', borderLeft: '1px solid #e4e9f2' }}>
                <div style={{ marginBottom: '45px', flexDirection: 'row', display: 'flex' }}>
                  <div className='icon-background' style={{ marginLeft: '20px' }}>
                    <img src={law} style={{ width: '25px' }} />
                  </div>
                  <div style={{ paddingLeft: '20px', textAlign: 'left' }}>
                    <p style={{ fontSize: '24px', color: '#242d51', fontFamily: 'Inter' }}>
                      Customisable
                  </p>
                    <p style={{ fontSize: '20px' }}>
                      Get additional branding and modifications for a tailored ticketing experience.
                  </p>
                  </div>
                </div>
              </div>
              <div style={{ width: '33%', float: 'left', borderLeft: '1px solid #e4e9f2' }}>
                <div style={{ marginBottom: '45px', flexDirection: 'row', display: 'flex' }}>
                  <div className='icon-background' style={{ marginLeft: '20px' }}>
                    <img src={ear} style={{ width: '25px' }} />
                  </div>
                  <div style={{ paddingLeft: '20px', textAlign: 'left' }}>
                    <p style={{ fontSize: '24px', color: '#242d51', fontFamily: 'Inter' }}>
                      Build hype
                  </p>
                    <p style={{ fontSize: '20px' }}>
                      Customers trust information coming from those they already trust.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 6 */}
        <div style={{ width: '100%', textAlign: 'center', marginTop: '-100px', backgroundColor: '#fff' }}>
          <div className='container'>
            <div style={{ width: '100%' }}>
              <div className="con">
                <div className="layer1" style={{ maxHeight: '350px', borderRadius: '35px', overflow: 'hidden' }}>
                  <video style={{ width: '100%', textAlign: 'center', borderRadius: '35px' }} autoPlay={true} loop={true}>
                    <source src={anim1} type="video/mp4" />
                  </video>
                </div>
                <div className="layer2" style={{ width: '100%', textAlign: 'center' }}>
                  <div className='container'>
                    <p style={{ fontSize: '24px', textAlign: 'center', marginTop: '50px', color: '#fff' }}>
                      Half a million in volume processed and growing                </p>
                    <p style={{ fontSize: '70px', textAlign: 'center', marginBottom: '50px', color: '#fff', fontFamily: 'Inter' }}>
                      JOIN FOR FREE
                  </p>
                    <div>
                      <a href='https://app.isotopeticketing.com/'>
                        <button className='new-button-white'>
                          START NOW
                      </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 7 */}
        <div style={{ height: 'auto', backgroundColor: '#f8f8f8', marginTop: '400px', marginBottom: '25px' }}>
          <div className='container'>
            <Row style={{ textAlign: 'center' }}>
              <Col style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                <div className='big-split-768' style={{ width: '100%', display: screen.width >= 768 ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ width: '20%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='../../../termsandconditions.pdf' target="_blank">
                      <h6 className='gray-text' >
                        Terms of Use
                        </h6>
                    </a>
                  </div>
                  <div style={{ width: '20%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='../../../privacy-policy.pdf' target="_blank">
                      <h6 className='gray-text' >
                        Privacy Policy
                                    </h6>
                    </a>
                  </div>
                  <div style={{ width: '20%' }}>
                    <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                    <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                    <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                  </div>
                  <div style={{ width: '20%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                      <h6 className='gray-text' >
                        &copy; Isotope Ticketing 2021
                                    </h6>
                    </a>
                  </div>
                  <div style={{ width: '20%' }}>
                    <h6 className='gray-text'>
                      Powered by Stripe
               					</h6>
                  </div>
                </div>
                <div className='small-split-768' style={{ textAlign: 'center' }}>
                  <div style={{ width: '100%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                      <h6 className='gray-text' >
                        &copy; Isotope Ticketing 2021<br /><br />
                      </h6>
                    </a>
                  </div>
                  <div style={{ width: '100%' }}>
                    <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                    <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                    <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                  </div>
                  <div style={{ width: '100%' }}>
                    <h6 className='gray-text'>
                      <br />Powered by Stripe
                    				</h6>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* THE FOLLOWING IS CODE FOR THE LANDING PAGE FOR DEVICES WITH SCREEN WIDTHS UNDER 768 */}
      <div className='small-split-768'>
        {/* BLOCK 1 */}
        <div>
          <div className='container'>
            <p style={{ paddingTop: '100px', fontSize: '42px', fontFamily: 'Inter', color: '#242d51' }}>
              Promote<br />Your Events<br />
              <div className='cut-text' style={{ color: '#fff', borderRadius: '15px', backgroundColor: '#242d51', width: 'auto', maxWidth: 425 }}>
                {/* <TextLoop interval={1500} className='cut-text'>
                  <span>
                    &nbsp;events&nbsp;
                  </span>
                  <span>
                    &nbsp;concerts&nbsp;
                </span>
                  <span>
                    &nbsp;drive-ins&nbsp;
                </span>
                  <span>
                    &nbsp;clubs&nbsp;
                </span>
                  <span>
                    &nbsp;festivals&nbsp;
                </span>
                  <span>
                    &nbsp;merch&nbsp;
                </span>
                </TextLoop> */}
                &nbsp;Successfully.&nbsp;
              </div>
            </p>
            <p style={{ fontSize: '26px', paddingTop: '10px', paddingBottom: '10px' }}>
              Empower your team to maximise outreach and increase word-of-mouth for a memorable event.
            </p>
            <div style={{ flexDirection: 'row', textAlign: 'left', marginBottom: '50px' }}>
              <a href='https://app.isotopeticketing.com/'>
                <button className='new-button-blue-gradient'>
                  START NOW
              </button>
              </a>
              <a href='mailto:info@isotopeticketing.com'>
                <button className='new-button-blue-outline' style={{ marginLeft: '25px' }}>
                  CONTACT SALES
              </button>
              </a>
            </div>
          </div>
          <div>
            <div className="con" style={{ width: '100%' }}>
              <div className="layer1" style={{ textAlign: 'center', marginTop: '50px', marginBottom: '50px' }}>
                <video style={{ width: '80%', borderRadius: '15px' }} autoPlay={true} loop={true}>
                  <source src={anim2} type="video/mp4" />
                </video>
              </div>
              <div className="layer2" style={{ width: '100%', textAlign: 'center' }}>
                <img src={mobileDashboard} style={{ width: '50%' }} />
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 2 */}
        <div style={{ width: '100%', textAlign: 'left', marginTop: 450 }}>
          <p style={{ paddingLeft: '8%', paddingRight: '8%', fontSize: '40px', fontFamily: 'Inter', color: '#242d51', width: '100%', textAlign: 'center' }}>
            Harness the power of affiliate marketing.
        </p>
          <img src={center} style={{ width: '95%', marginBottom: '20px' }} />
          <p style={{ paddingLeft: '10%', paddingRight: '10%', fontSize: '26px' }}>
            Turn your promoters and their sub-promoters into more points-of-sale.
            Isotope ensures that each affiliate receives a fair share of commission.
            </p>
          <div style={{ textAlign: 'center', width: '100%' }}>
            <img src={illustration} style={{ width: '100%', textAlign: 'center', marginTop: '25px', marginBottom: '50px' }} />
          </div>
        </div>
        {/* BLOCK 3 */}
        <div style={{ width: '100%', textAlign: 'left' }}>
          <div ref={this.myRef2}
            style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <p style={{ fontSize: '20px' }}>
                DESIGNED FOR
              </p>
              <div className='cut-text' style={{
                color: '#fff', borderRadius: '15px', backgroundColor: '#242d51',
                width: 'auto', float: 'left',
                fontSize: '40px', fontFamily: 'Inter',
              }}>
                <TextLoop interval={1500}>
                  <span>
                    &nbsp;AFFILIATES&nbsp;
                  </span>
                  <span>
                    &nbsp;AMBASSADORS&nbsp;
                </span>
                  <span>
                    &nbsp;PROMOTERS&nbsp;
                </span>
                </TextLoop>
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 4 */}
        <div style={{ width: '100%', textAlign: 'left' }}>
          <div className='container'>
            <p style={{ fontSize: '26px', textAlign: 'left', marginBottom: '50px', paddingTop: '20px' }}>
              Promoters can share unique links to capture a wide variety of audiences. Event-goers can directly purchase inventory from these links, whether it be tickets or tables.
            </p>
            <div style={{ width: '100%', textAlign: 'left' }}>
              <img src={events} style={{ width: '100%', float: 'right' }} />
            </div>
          </div>
        </div>
        {/* BLOCK 5 */}
        <div style={{ width: '100%', textAlign: 'center', marginTop: '400px', backgroundColor: '#fff' }}>
          <div className='container'>
            <p style={{ fontSize: '43px', textAlign: 'left', marginBottom: '25px', color: '#242d51', fontFamily: 'Inter', paddingTop: '50px', paddingBottom: '50px' }}>
              WHY ISOTOPE
          </p>
            <div style={{ width: '100%', textAlign: 'left' }}>
              <div style={{ marginBottom: '45px', flexDirection: 'row', display: 'flex' }}>
                <div className='icon-background'>
                  <img src={tool} style={{ width: '25px' }} />
                </div>
                <div style={{ paddingLeft: '20px' }}>
                  <p style={{ fontSize: '24px', color: '#242d51', fontFamily: 'Inter' }}>
                    All-In-One
                  </p>
                  <p style={{ fontSize: '20px' }}>
                    Manage inventory & affiliate commissions, send email-blasts to customers, check-in tickets, etc.
                  </p>
                </div>
              </div>
              <div style={{ marginBottom: '45px', flexDirection: 'row', display: 'flex' }}>
                <div className='icon-background'>
                  <img src={law} style={{ width: '25px' }} />
                </div>
                <div style={{ paddingLeft: '20px' }}>
                  <p style={{ fontSize: '24px', color: '#242d51', fontFamily: 'Inter' }}>
                    Customisable
                  </p>
                  <p style={{ fontSize: '20px' }}>
                    Get additional branding and modifications for a tailored ticketing experience.
                  </p>
                </div>
              </div>
              <div style={{ marginBottom: '45px', flexDirection: 'row', display: 'flex' }}>
                <div className='icon-background'>
                  <img src={ear} style={{ width: '25px' }} />
                </div>
                <div style={{ paddingLeft: '20px' }}>
                  <p style={{ fontSize: '24px', color: '#242d51', fontFamily: 'Inter' }}>
                    Build hype
                  </p>
                  <p style={{ fontSize: '20px' }}>
                    Customers trust information coming from those they already trust.
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BLOCK 6 */}
        <div style={{ width: '100%', textAlign: 'center', marginTop: '125px', backgroundColor: '#fff' }}>
          <div className='container'>
            <div style={{ width: '100%', marginTop: '-50px' }}>
              <div className="con">
                <div className="layer1" style={{ maxHeight: '500px', borderRadius: '35px', overflow: 'hidden' }}>
                  <video style={{ width: '100%', textAlign: 'center', borderRadius: '35px' }} autoPlay={true} loop={true}>
                    <source src={anim1} type="video/mp4" />
                  </video>
                </div>
                <div className="layer2" style={{ width: '100%', textAlign: 'center' }}>
                  <div className='container'>
                    <p style={{ fontSize: '18px', textAlign: 'center', color: '#fff', marginTop: screen.width > 550 ? '50px' : '20px' }}>
                      Half a million in volume processed and growing
                      </p>
                    <p style={{ fontSize: '30px', textAlign: 'center', color: '#fff', fontFamily: 'Inter' }}>
                      JOIN FOR FREE
                  </p>
                    <div style={{ paddingTop: screen.width < 440 ? '75px' : '0px' }}>
                      <a href='https://app.isotopeticketing.com/'>
                        <button className={screen.width < 440 ? 'new-button-blue-gradient' : 'new-button-white'}>
                          START NOW
                      </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* BLOCK 7 */}
        <div style={{ height: 'auto', backgroundColor: '#f8f8f8', marginTop: screen.width < 575 ? '425px' : '550px', marginBottom: '25px', }}>
          <div className='container'>
            <Row style={{ textAlign: 'center' }}>
              <Col style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                <div className='big-split-768' style={{ width: '100%', display: screen.width >= 768 ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ width: '20%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                      <h6 className='gray-text' >
                        &copy; Isotope Ticketing 2021
                                    </h6>
                    </a>
                  </div>
                  <div style={{ width: '20%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                      <h6 className='gray-text' >
                        &copy; Isotope Ticketing 2021
                                    </h6>
                    </a>
                  </div>
                  <div style={{ width: '20%' }}>
                    <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                    <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                    <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                  </div>
                  <div style={{ width: '20%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                      <h6 className='gray-text' >
                        &copy; Isotope Ticketing 2021
                                    </h6>
                    </a>
                  </div>
                  <div style={{ width: '20%' }}>
                    <h6 className='gray-text'>
                      Powered by Stripe
               					</h6>
                  </div>
                </div>
                <div className='small-split-768' style={{ textAlign: 'center' }}>
                  <div style={{ width: '100%' }}>
                    <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                    <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                    <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                  </div>
                  <div style={{ width: '100%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='../../termsandconditions.pdf' target="_blank">
                      <h6 className='gray-text' >
                        <br />Terms of Use
                      </h6>
                    </a>
                  </div>
                  <div style={{ width: '100%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='../../../privacy-policy.pdf' target="_blank">
                      <h6 className='gray-text' >
                        <br />Privacy Policy
                      </h6>
                    </a>
                  </div>
                  <div style={{ width: '100%' }}>
                    <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                      <h6 className='gray-text' >
                        <br /> &copy; Isotope Ticketing 2021
                      </h6>
                    </a>
                  </div>
                  <div style={{ width: '100%' }}>
                    <h6 className='gray-text'>
                      <br />Powered by Stripe
                    	</h6>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div >
  }
}


// WEBPACK FOOTER //
// ./src/pages/Landing.page.tsx